var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "_Ebene_",
    x: 0,
    y: 0,
    enableBackground: "new 0 0 24 24",
    focusable: "false",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5776367,12.869873C14.4631348,11.8240967,15,10.4742432,15,8.9997559c0-3.3085938-2.6914062-6-6-6s-6,2.6914062-6,6 s2.6914062,6,6,6c1.4746094,0,2.824585-0.5369873,3.8703613-1.4226074l6.776123,6.776123l0.7070312-0.7070312L13.5776367,12.869873z M9,13.9997559c-2.7568359,0-5-2.2431641-5-5s2.2431641-5,5-5s5,2.2431641,5,5S11.7568359,13.9997559,9,13.9997559z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e52932e354a7f666e25c106cc6e37a38.svg";
export { ForwardRef as ReactComponent };